<template>
  <div class="list">
    <knowledgePersonal
      v-if="checkUserId"
      :classChapterId="classChapterId"
      :userId="checkUserId"
      :name="checkNickName"
      ref="PInfo"
    />

    <div class="main" v-else>
      <div class="box_title">知识考核个人排名</div>
      <div class="rank_box">
        <div
          class="one"
          v-for="item in list"
          :key="item.userId"
          @click="goDetail(item.userId, item.nickName)"
        >
          <span class="score" :style="{ bottom: item.score * 0.85 + '%' }"
            >{{ Number((item.score || 0).toFixed(1)) }}分</span
          >
          <div class="zhu" :style="{ height: item.score * 0.8 + '%' }"></div>
          <span class="name">{{ item.nickName }}</span>
        </div>
      </div>

      <div class="score_row">
        <div class="score_box">
          <p class="score_title">最高分</p>
          <div class="circle_box">
            <el-progress
              v-if="show"
              type="circle"
              :percentage="highest"
              color="#aae476"
              stroke-linecap="square"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress>
            <!-- <span class="text">分</span> -->
          </div>
        </div>
        <div class="score_box">
          <p class="score_title">平均分</p>
          <div class="circle_box">
            <el-progress
              v-if="show"
              type="circle"
              :percentage="average"
              color="#aae476"
              stroke-linecap="square"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress>
            <!-- <span class="text">分</span> -->
          </div>
        </div>
        <div class="score_box">
          <p class="score_title">最低分</p>
          <div class="circle_box">
            <el-progress
              v-if="show"
              type="circle"
              :percentage="lowest"
              color="#aae476"
              stroke-linecap="square"
              :width="105"
              :stroke-width="10"
              :format="format"
            ></el-progress>
            <!-- <span class="text">分</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userScoreList } from "@/api/evaluation";
import { getArrayStatistic } from "@/utils";

import knowledgePersonal from "./knowledgePersonal.vue";

export default {
  components: {
    knowledgePersonal,
  },
  props: {
    classChapterId: Number,
  },
  data() {
    return {
      getArrayStatistic,
      list: [],
      checkUserId: null,
      checkNickName: "",
      show: false,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    highest() {
      return this.getArrayStatistic(this.list, "score", "max");
    },
    lowest() {
      return this.getArrayStatistic(this.list, "score", "min");
    },
    average() {
      return this.getArrayStatistic(this.list, "score", "avg");
    },
  },
  methods: {
    // 个人习题情况列表
    getList(classChapterId) {
      this.$loading.show();
      userScoreList({
        classId: this.$route.query.id,
        classChapterId: classChapterId || this.classChapterId,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
          this.show = true;
        } else {
          console.log(res.msg);
        }
      });
    },
    format(percentage) {
      return percentage + "";
    },
    goDetail(userId, nickName) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          userId
        }
      })
      this.checkUserId = userId;
      this.checkNickName = nickName;
      //   this.$emit("handleCheck", userId);
    },
  },
};
</script>


<style lang="less" scoped>
.list {
  .main {
    margin: 20px 2px 0;
    .box_title {
      padding: 0 10px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #1de0fe;
      background-color: rgba(49, 70, 125, 0.1);
      // border: solid 1px rgba(4, 20, 40, 0.1);
      box-shadow: #6be4f7 0px 0px 5px inset;
    }
    .rank_box {
      padding: 24px 30px;
      height: 307px;
      box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
      text-align: left;
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      &::-webkit-scrollbar {
        height: 6px;
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        background-color: #1ae0fe;
      }

      .one {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 240px;
        text-align: center;
        vertical-align: bottom;
        &:not(:last-child) {
          margin-right: 28px;
        }
        &:hover {
          .zhu {
            transform: scaleX(1.2);
          }
        }
        .score {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          margin-bottom: 17px;
          font-size: 16px;
          color: #6be015;
          transition: all 0.3s ease;
        }
        .zhu {
          position: absolute;
          bottom: 0;
          margin: 15px 0;
          width: 100%;
          background-color: #6be015;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .name {
          position: absolute;
          left: 50%;
          bottom: -20px;
          transform: translateX(-50%);
          color: #65c6e7;
          font-size: 15px;
        }
      }
    }
    .score_row {
      margin-top: 15px;
      .score_box {
        display: inline-block;
        width: 390px;
        &:not(:last-child) {
          margin-right: 10px;
        }
        .score_title {
          padding: 0 10px;
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          color: #1de0fe;
          background-color: rgba(49, 70, 125, 0.1);
          // border: solid 1px rgba(4, 20, 40, 0.1);
          box-shadow: #1de0fe 0px 0px 5px inset;
        }
        .circle_box {
          position: relative;
          padding-top: 43px;
          height: 190px;
          box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
          ::v-deep .el-progress__text {
            // padding-right: 10px;
            color: #aae476;
            font-size: 30px !important;
          }
          .text {
            position: absolute;
            top: 47%;
            right: 42%;
            color: #aae476;
          }
        }
      }
    }
  }
}
</style>